export default "__VITE_ASSET__BJ12iR0x__"